import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcHFAHSDetails from './NcHFAHSDetails';

const NcHFAHSModal = ({ selectedPayable, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            External Bill Id: {selectedPayable.externalBillId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcHFAHSDetails selectedPayable={selectedPayable} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcHFAHSModal;

NcHFAHSModal.propTypes = {
  selectedPayable: PropTypes.instanceOf(Object).isRequired,
};
